import { IMultiOccurrence, IMultiOccurrenceOptions } from '../../../../../core/services/multi-occurrence.service';
import { IMenuClass } from '../../../../../core/services/menu/menu.service';
import { IMenuItemActionClass } from '../../../../../core/services/menu/menu-item-action.service';
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IPaginationClass } from '../../../../../core/services/pagination.service';

interface IPageAl2014 {
    multiOccurrenceOptions: IMultiOccurrenceOptions;
    multiOccurrence: IMultiOccurrence;
    valeursEcran: any;
}
/* @ngInject */
export default function Al2014Controller(
    Menu: IMenuClass, 
    MenuItemAction: IMenuItemActionClass, 
    Pagination: IPaginationClass,
    ecranDetails: IEcranDetailsResourcesEntite) {
        
    const vm: IPageAl2014 = this;

    vm.valeursEcran = ecranDetails.valeurs;

    vm.multiOccurrenceOptions = {
        actions: new Menu([
            new MenuItemAction(
                'LBL_BTN_RAFFRAICHIR', 
                'BOURAF', 
                () => ({}), 
                {
                    iconButton: false,
                    class: 'ex-button-action ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
                    successAction: () => {
                        vm.multiOccurrence.fetchDataList();
                    }
                }
            ),            
            new MenuItemAction('LBL_BTN_EFFACER', 'BOUEFFACER', () => ({}), {
                iconButton: false,
                class: 'ex-button-secondary ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
                successAction: () => {
                    vm.multiOccurrence.fetchDataList();
                }
            }),
            new MenuItemAction('LBL_BTN_TRUNCATE', 'BOUTRUNCATE', () => ({}), {
                iconButton: false,
                class: 'ex-button-secondary ex-accent-hue-1-bg ex-accent-hue-2-bg--hover md-raised',
                successAction: () => {
                    vm.multiOccurrence.fetchDataList();
                },
                messageConfirmation: {
                    message: 'BOUTRUNCATE_CONFIRM'
                }
            })
        ]),
        fonctions: {
            rechercheCollapsable: false,
            suiviModification: false,
            pagination: true
        },
        pagination: new Pagination({
            nombreElementPage: 500,
            nbElementsPossibles: [500, 1000]
        }),
        colonnesVisibles: [{ nom: 'dsimsg', largeur: 800 }]
    };
}
